import { render } from "./DemoDepartmentsView.vue?vue&type=template&id=a8703488&scoped=true"
import script from "./DemoDepartmentsView.vue?vue&type=script&lang=js"
export * from "./DemoDepartmentsView.vue?vue&type=script&lang=js"

import "./DemoDepartmentsView.vue?vue&type=style&index=0&id=a8703488&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8703488"]])

export default __exports__